import request from '@utils/request';
import ApiHost from '@services/api-config';
import { AxiosPromise } from 'axios';
import { getState } from 'jumpstate';

export const sendInviteEmails = (data: { emailList: string}): AxiosPromise<RequestResponse<null>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/email/send`,
		data,
		headers: {
			'Accept-Language': getState().app.local
		}
	})
}

export type ListItem = {
	userId: string;
	// userName: string;
	userInfo: {
		firstName: string;
		avatar: string;
	};
	status: number;
}

export type ResponseData = {
	total: number;
	records: ListItem[] | null;
}
export const getReferralData = (data: { pageNo: number; pageSize: number }): AxiosPromise<RequestResponse<ResponseData>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api//api/referral`,
		data,
	})
}
